<template>
    <div class="page gc">
        <SideMenu />

        <div class="page-content g9">
            <h2>{{ project.title }}</h2>

            <Accord :title="(isActives ? 'Active' : 'Archived') + ' programs'">
                <div class="grid-33w">
                    <ProjectTile :info="program" :key="program.programId" v-for="program in project.programs.filter(x => x.isArchived == !isActives)"></ProjectTile>

                    <div class="tile tile-project tile-project-create" v-if="isActives && !project.isArchived">
                        <p v-on:click="onNewProgramClick">
                            Create program
                        </p>
                    </div>
                </div>
            </Accord>
        </div>

        <Modal title="Create program" ref="modalNewProgram">
            <form v-on:submit="onNewProgramSubmit">
                <div class="input" type="text">
                    <label>
                        <span>Name</span>
                        <input type="text" ref="programNameInput" placeholder="New program name" v-model="newProgramName"/>
                    </label>
                </div>

                <button class="right edit" v-bind:class="{ 'loading': isLoading }">Create program</button>
            </form>
        </Modal>
    </div>
</template>

<script>
    import API from "../../Api"
    import SideMenu from "../Components/SideMenuPrograms.vue"
    import Accord from "../Components/Accord.vue"
    import ProjectTile from "../Components/ProjectTile.vue"
    import Modal from "../Components/Modal.vue"
    import { mapGetters } from "vuex"

    export default {
        components: {
            SideMenu,
            Accord,
            ProjectTile,
            Modal
        },
        data: () => ({
            newProgramName: null,
            isLoading: false
        }),
        computed:{
            project(){
                return this.$store.getters.project(this.$route.params.id)
            },
            isActives(){
                return this.$route.name == "programsActive"
            }
        },
        mounted(){
            document.title = this.project.title;
        },
        methods: {
            onNewProgramClick() {
                this.$refs.modalNewProgram.show();
                this.$nextTick(() => this.$refs.programNameInput.focus())
            },
            onNewProgramSubmit(e) {
                e.preventDefault();

                this.isLoading = true;

                if(this.newProgramName == "")
                {
                    this.isLoading = false;
                    return false;
                }

                var newProgram = {
                    title: this.newProgramName,
                    template: "",
                    parentId: this.project.projectId
                };

                this.$store.dispatch("setProgram", newProgram).then((res) => {
                    this.$router.push(res.data.url)
                }).catch((res) => {
                    this.isLoading = false;
                })
            }
        }
    }
</script>
